import { OpaqueToken } from '@angular/core';

export const WindowService = new OpaqueToken("WindowService");



// WEBPACK FOOTER //
// ./src/app/services/window.service.ts